import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const buyFeatureControlStore = Store.createStore({
    /**
     * Current Buy Feature bet value.
     */
    buyFeature_bet: Store.signal(0),

    /**
     * Formatted version of current Buy Feature bet value.
     */
    buyFeature_betFormatted: Store.signal(''),

    /**
     * List of all available bets to select.
     */
    buyFeature_betList: Store.signal([0]),
});